import { render, staticRenderFns } from "./ModalEventsPage.vue?vue&type=template&id=1d3f3fd2&"
import script from "./ModalEventsPage.vue?vue&type=script&lang=js&"
export * from "./ModalEventsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports